import React, { useState } from 'react'

import { RecipeTile as PureRecipeTile } from '@features/recipe-tile'
import type { RecipeTileProps } from '@features/recipe-tile/src/components/RecipeTile'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { useRecipeOptions } from 'routes/Menu/domains/menu'
import { useScrollableBasket } from 'routes/Menu/hooks/useScrollableBasket'

export const RecipeTile = (
  props: Omit<
    RecipeTileProps,
    'alternativeOptions' | 'isOutOfStock' | 'isInBasket' | 'isScrollableBasketEnabled'
  >,
) => {
  const [shouldFetchOptions, setShouldFetchOptions] = useState(false)

  const { recipe } = props

  const { alternativeOptions, isLoadingOptions } = useRecipeOptions(recipe, shouldFetchOptions)

  const isOutOfStock = !useIsRecipeInStock(recipe.id)

  const { basketHasRecipe } = useBasketRecipes()
  const isScrollableBasketEnabled = useScrollableBasket()

  return (
    <PureRecipeTile
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      alternativeOptions={alternativeOptions}
      isOutOfStock={isOutOfStock}
      isInBasket={basketHasRecipe(recipe.coreId)}
      onOpenAlternativeOptions={() => setShouldFetchOptions(true)}
      isLoadingOptions={isLoadingOptions}
      isScrollableBasketEnabled={isScrollableBasketEnabled}
    />
  )
}
